import { Link } from "react-router-dom";
import { formatNumber } from "../../utils/data/essential";
import Skeleton from "react-loading-skeleton";

const AccountsCard = ({ accountsData }) => {
  return (
    <div className='card mt-3 dashboard-card-width'>
      <div>
        <div className='d-flex justify-content-center'>
          <Link to={`/loggedin/all-accounts/${accountsData?.locationId}`}>
            <h4>
              Konti{" "}
              {accountsData && (
                <span style={{ color: "#3a0ca3" }}>
                  (
                  {accountsData ? (
                    <b style={{ fontSize: 18, color: "#3a0ca3" }}>
                      {formatNumber(accountsData?.allAccounts)}
                    </b>
                  ) : (
                    <Skeleton />
                  )}
                  )
                </span>
              )}
            </h4>
          </Link>
        </div>
        <div
          className='d-flex justify-content-between mt-3 flex-column-on-mobile'
          style={{ gap: 10 }}
        >
          <Link to={`/loggedin/paid-accounts/${accountsData?.locationId}`}>
            <div className='d-flex flex-column' style={{ gap: "10" }}>
              <h5 style={{ color: "#696060", whiteSpace: "nowrap" }}>
                Izishyuye uku kwezi{" "}
              </h5>
              <h6 className='ml-1' style={{ color: "#3a0ca3", fontSize: 20 }}>
                {accountsData && (
                  <span style={{ color: "#3a0ca3" }}>
                    (
                    {accountsData ? (
                      <b style={{ fontSize: 18, color: "#3a0ca3" }}>
                        {formatNumber(accountsData?.accountsWithNoOutstanding)}
                      </b>
                    ) : (
                      <Skeleton />
                    )}
                    )
                  </span>
                )}
                <b>
                  {accountsData ? (
                    <b>
                      {" " +
                        formatNumber(
                          accountsData?.currentMonthTotalCollection
                        ) +
                        " Rwf"}
                    </b>
                  ) : (
                    <div>
                      <Skeleton />
                    </div>
                  )}
                </b>
              </h6>
            </div>
          </Link>
          <Link to={`/loggedin/unpaid-accounts/${accountsData?.locationId}`}>
            <div className='d-flex flex-column' style={{ gap: "10" }}>
              <h5
                style={{
                  color: "#696060",
                  display: "block",
                  whiteSpace: "wrap",
                }}
              >
                Ibirarane byose{" "}
              </h5>
              <h6 className='ml-1' style={{ color: "#3a0ca3", fontSize: 20 }}>
                {accountsData && (
                  <span style={{ color: "#3a0ca3" }}>
                    (
                    {accountsData ? (
                      <b style={{ fontSize: 18, color: "#3a0ca3" }}>
                        {formatNumber(accountsData?.accountsWithOutstanding)}
                      </b>
                    ) : (
                      <Skeleton />
                    )}
                    )
                  </span>
                )}
                <b>
                  {accountsData ? (
                    " " +
                    formatNumber(accountsData?.overallTotalOutstanding) +
                    " Rwf"
                  ) : (
                    <Skeleton />
                  )}
                </b>
              </h6>
            </div>
          </Link>
        </div>
        <div className='d-flex justify-content-center'>
          <Link
            to={`/loggedin/unpaid-accounts-this-month/${accountsData?.locationId}`}
          >
            <div className='d-flex flex-column' style={{ gap: "10" }}>
              <h5 style={{ color: "#696060", whiteSpace: "nowrap" }}>
                Izitarishyura uku kwezi gusa
              </h5>
              <h6 className='ml-1' style={{ color: "#3a0ca3", fontSize: 20 }}>
                {accountsData && (
                  <span style={{ color: "#3a0ca3" }}>
                    (
                    {accountsData ? (
                      <b style={{ fontSize: 18, color: "#3a0ca3" }}>
                        {formatNumber(
                          accountsData?.accountsWithCurrentMonthOutstanding
                        )}
                      </b>
                    ) : (
                      <Skeleton />
                    )}
                    )
                  </span>
                )}
                <b>
                  {accountsData ? (
                    " " + formatNumber(accountsData?.currentMonthTotalOutstanding) +
                    " Rwf"
                  ) : (
                    <Skeleton />
                  )}
                </b>
              </h6>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AccountsCard;
